import { useEffect, useRef } from 'react';

/**
 * VolumeIndicator - Shows real-time input (mic) and output (speaker) volume levels for an active call.
 */
const VolumeIndicator = ({ call, isActive }) => {
  const inputBarRef = useRef(null);
  const outputBarRef = useRef(null);

  useEffect(() => {
    if (!call || !isActive) return;

    const handleVolume = (inputVolume, outputVolume) => {
      if (inputBarRef.current) {
        inputBarRef.current.style.width = `${Math.floor(inputVolume * 100)}%`;
      }
      if (outputBarRef.current) {
        outputBarRef.current.style.width = `${Math.floor(outputVolume * 100)}%`;
      }
    };

    call.on('volume', handleVolume);
    return () => call.removeListener('volume', handleVolume);
  }, [call, isActive]);

  if (!isActive) return null;

  return (
    <div style={{ marginTop: 8, width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 3 }}>
        <i className="las la-microphone" style={{ width: 18, fontSize: 12, color: '#666' }} title="Your microphone" />
        <div style={{ flex: 1, height: 6, background: '#e9ecef', borderRadius: 3, overflow: 'hidden' }}>
          <div ref={inputBarRef} style={{ height: '100%', borderRadius: 3, width: '0%', background: '#28a745' }} />
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <i className="las la-volume-up" style={{ width: 18, fontSize: 12, color: '#666' }} title="What you hear" />
        <div style={{ flex: 1, height: 6, background: '#e9ecef', borderRadius: 3, overflow: 'hidden' }}>
          <div ref={outputBarRef} style={{ height: '100%', borderRadius: 3, width: '0%', background: '#28a745' }} />
        </div>
      </div>
    </div>
  );
};

export default VolumeIndicator;
